/**
 * Remove Froala "Powered by Froala Editor" attribution/footer markup from HTML.
 *
 * We do this defensively at send/save boundaries to avoid persisting the footer
 * in emails/templates when it appears (e.g. trial/unlicensed/editor config edge cases).
 */
export default function stripFroalaAttribution(html) {
  if (typeof html !== 'string' || html.length === 0) return html;

  const lower = html.toLowerCase();
  const mightContainAttribution =
    lower.includes('data-f-id="pbf"') ||
    lower.includes("data-f-id='pbf'") ||
    lower.includes('froala.com/wysiwyg-editor') ||
    lower.includes('powered by') ||
    lower.includes('froala editor');

  if (!mightContainAttribution) return html;

  // Preferred: DOM-based removal (more robust than regex for attribute ordering).
  try {
    // eslint-disable-next-line no-undef
    const parser = new DOMParser();
    const doc = parser.parseFromString(
      `<div id="__froala_root__">${html}</div>`,
      'text/html'
    );
    const root = doc.getElementById('__froala_root__');
    if (!root) return html;

    // Remove known Froala attribution marker.
    root.querySelectorAll('[data-f-id="pbf"]').forEach(el => el.remove());

    // Remove "Powered by Froala Editor" blocks that contain the Froala promo link.
    root.querySelectorAll('a[href]').forEach(a => {
      const href = a.getAttribute('href') || '';
      const isFroalaPromo =
        /froala\.com\/wysiwyg-editor/i.test(href) && /[?&]pb=1\b/i.test(href);

      if (!isFroalaPromo) return;

      const container = a.closest('p') || a.closest('div') || a;
      const text = (container.textContent || '').replace(/\s+/g, ' ').trim();
      if (/powered by/i.test(text)) {
        container.remove();
      } else {
        a.remove();
      }
    });

    // Fallback: remove any paragraph that is *exactly* "Powered by Froala Editor".
    root.querySelectorAll('p').forEach(p => {
      const text = (p.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^powered by froala editor$/i.test(text)) {
        p.remove();
      }
    });

    return root.innerHTML;
  } catch (e) {
    // ignore and fall back to regex
  }

  // Regex fallback (covers common snippets seen in email bodies).
  return (
    html
      // Froala footer paragraph marker (data-f-id="pbf")
      .replace(/<p\b[^>]*\bdata-f-id=(["'])pbf\1[^>]*>[\s\S]*?<\/p>/gi, '')
      // Froala promo link footer
      .replace(
        /<p\b[^>]*>\s*powered by\s*<a\b[^>]*froala\.com\/wysiwyg-editor[^>]*\bpb=1\b[^>]*>[\s\S]*?<\/a>\s*<\/p>/gi,
        ''
      )
  );
}
